import { render, staticRenderFns } from "./select-order-part.vue?vue&type=template&id=0f223e28"
import script from "./select-order-part.vue?vue&type=script&lang=js"
export * from "./select-order-part.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports